import React, { useCallback } from "react";
import { useApi } from "./api";

export const CargaRequester = () => {

  const { api } = useApi();

  const onChange = useCallback(() => {
    api.post<{ message: string; id: string; }>(`cargaTabelas/start`).then(resp => {
      alert('resposta da carga: ' + resp.data.id);
    }).catch(error => {
      if (error.response) {
        alert(error.response.data);
      }

    });

  }, [api]);

  return (
    <div>
      <button onClick={onChange}>Solicitar Nova Carga</button>
    </div>
  );
};
